module.exports = __webpack_public_path__ + "img/ardor-hero_md.36c5c83.webp";